    
import React from "react";

function SearchInfo(props) {
  return (
      <div>
        {
          props.searchFilters && props.searchFilters.cancerType && props.searchFilters.cancerType.text
          && props.searchFilters.searchEntityType
          && (
            props.searchFilters.searchEntityType === 'services'
            && (
               <h2 tabindex="0"><span class="bold">Cancer services</span> treating <span class="bold">{props.searchFilters.cancerType.text.toLowerCase()}</span> near <span class="bold">{props.searchFilters.location.text}</span>.
                <br/>
                {
                  props.searchFilters.treatmentTypes
                  && props.searchFilters.treatmentTypes.length > 0
                  && `Showing services with the following types of treatment: ${props.searchFilters.treatmentTypes.map(t => t.Text).join(', ').toLowerCase()}`
                }
              </h2>
            )

            ||
            props.searchFilters.searchEntityType === 'teams'
                  && <h2 tabindex="0"><span class="bold">Multidisciplinary cancer care teams</span> treating <span class="bold">{props.searchFilters.cancerType.text.toLowerCase()}</span> near <span class="bold">{props.searchFilters.location.text}</span>.</h2>
            ||
            props.searchFilters.searchEntityType === 'specialists'
            && (
              <h2 tabindex="0"><span class="bold">Cancer specialists</span> treating <span class="bold">{props.searchFilters.cancerType.text.toLowerCase()}</span> near <span class="bold">{props.searchFilters.location.text}</span>.
                {
                  props.searchFilters.doctorTypes
                  && props.searchFilters.doctorTypes.length > 0
                  && (props.searchFilters.doctorTypes.filter(t => t.checked).length > 0 || props.searchFilters.doctorTypes.map(t => t.DoctorTypes.filter(t => t.checked)).filter(t => t && t.length > 0).length > 0)
                  && (<div>Showing the following types of specialist: {props.searchFilters.doctorTypes
                        .filter(t => t.checked).
                        map(t => t.Text)
                        .concat(props.searchFilters.doctorTypes
                          .filter(t => !t.checked)
                          .map(t => t.DoctorTypes
                            .filter(t => t.checked).map(t => t.Text).join(', '))
                          .filter(t => t && t.length > 0))
                        .join(', ').toLowerCase()}</div>)
                }
                {
                  props.searchFilters.language
                  && (<div>Showing the following language: {props.searchFilters.language.text}</div>)
                }
                {
                  props.searchFilters.gender
                  && (<div>Showing the following gender: {props.searchFilters.gender.text}</div>)

                }
              </h2>
            )
          )
        }
      </div>
  );
}

export default SearchInfo;